import uuid from "uuid"
import database from "../firebase/firebase"

// ADD_ACCOUNT
export const addPermisson = (permission) => ({
  type: "ADD_PERMISSION",
  permission,
})

export const startAddPermission = (permissionData = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    const { upload = false, download = true, readOnly = false, remove = true, note = "" } = permissionData

    const newPermission = { upload, download, readOnly, remove, note }
    //console.log('action/permissions: ', newPermission)
    return database
      .ref(`users/${uid}/permissions`)
      .push(newPermission)
      .then((ref) => {
        dispatch(
          addPermission({
            id: ref.key,
            ...newPermission,
          })
        )
      })
  }
}

// REMOVE_Permission
export const removePermission = ({ id } = {}) => ({
  type: "REMOVE_PERMISSION",
  id,
})

// EDIT_ACCOUNT
export const editPermission = (id, updates) => ({
  type: "EDIT_PERMISSION",
  id,
  updates,
})

// db.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle',
//     'location/state': 'Washington'
// })

//startEditLabel
// export const startEditLabel = ((id, updates) => {
//     return (dispatch, getState) => {
//         const uid = getState().auth.uid

//         return database.ref(`users/${uid}/labels/${id}`).update({
//             ...updates
//         })
//             .then(() => {
//                 dispatch(editLabel(id, updates))
//             })
//     }
// })

// course solution
// export const startRemoveLabel = ({ id } = {}) => {
//     console.log('startRemovelabel: ' + id)

//     return (dispatch, getState) => {
//         console.log("startRemoveBefore auth")
//         const uid = getState().auth.uid
//         return database.ref(`users/${uid}/labels/${id}`).remove().then(() => {
//             console.log('dbRemove: startRemovelabel: ' + id)
//             dispatch(removeLabel({ id }));
//         }).catch((e) => {
//             console.log('Remove Error: ', e)
//         });
//     };
//     console.log('startRemovelabelFooter: ' + id)
// };

// // SET_LabelS
// export const setPermissions = (permissions) => ({
//   type: "SET_ACCOUNTS",
//   permissions,
// })

export const setPermissions = (permissions) => ({
  type: "SET_PERMISSIONS",
  permissions,
})

// const parseResultsToAccounts = (snapshot) => {
//   const accounts = []
//   snapshot.forEach((child) => {
//     accounts.push({
//       id: child.key,
//       ...child.val(),
//     })
//   })

//   return accounts
// }

// export const startSetAccounts = () => {
//   return (dispatch, getState) => {
//     const uid = getState().auth.uid
//     return database
//       .ref(`users/${uid}/members`)
//       .once("value")
//       .then((snapshot) => {
//         //console.log(snapshot)
//         const accounts = parseResultsToAccounts(snapshot)
//         dispatch(setAccounts(accounts))
//       })
//       .catch((e) => {
//         console.log("Fetch Error: ", e)
//       })
//   }
// }

const parseResultsToPermissions = (snapshot) => {
  const permissions = []
  snapshot.forEach((child) => {
    permissions.push({
      id: child.key,
      ...child.val(),
    })
  })

  // const state_permissions = [...permissions]
  // console.log("spread permissions: ", [...permissions])
  return permissions
}

export const startSetPermissions = () => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    //defaultPermissions = permissions[{1,allowUpload:false,readOnly:false}]
    return database
      .ref(`users/${uid}/permissions`)
      .once("value")
      .then((snapshot) => {
        //console.log("startSetPermissions: ", snapshot)
        const permissions = parseResultsToPermissions(snapshot)
        //console.log("Parsed-startSetPermissions: ", permissions[0].allowUpload)
        dispatch(setPermissions(permissions))
      })
      .catch((e) => {
        console.log("Fetch Error: ", e)
      })
  }
}

// export const startAddLabel = (LabelData = {}) => {
//   return (dispatch) => {
//     const {
//       description = '',
//       note = '',
//       amount = 0,
//       createdAt = 0
//     } = LabelData;
//     const Label = { description, note, amount, createdAt };

//     return database.ref('Labels').push(Label).then((ref) => {
//       dispatch(addLabel({
//         id: ref.key,
//         ...Label
//       }));
//     });
//   };
// };



// WEBPACK FOOTER //
// ./src/actions/permissions.js